const cativationPriceReducer = (state = { list : [], selected: null }, action) => {
  switch (action.type) {
    case "GET_CATIVATION_PRICE_LIST_SUCCESS":
      return { ...state, list: action.payload }
    case "GET_CATIVATION_PRICE_DETAILS_SUCCESS":
      return { ...state, selected: action.payload }
    default:
      return state
  }
}

export default cativationPriceReducer
